import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiHandle } from "../config/apiHandle.js";
import { type_constant } from "../utils/asyncStatus.js";

export const getAllOrdersAsync = createAsyncThunk(
  type_constant.GET_ALL_ORDERS_ASYNC,
  async () => {
    try {
      const response = await apiHandle.get(`get-orders`);
      const res_data = await response.data;
      return res_data;
    } catch (error) {
      console.log("error", error);
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      } else {
        throw Error(error.message);
      }
    }
  }
);

export const getOderByIdAsync = createAsyncThunk(
  type_constant.GET_ORDER_BY_ID_ASYNC,
  async (id) => {
    try {
      const response = await apiHandle.get(`/view-order/${id}`);
      const res_data = await response.data;
      return res_data;
    } catch (error) {
      console.log("error", error);
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      } else {
        throw Error(error.message);
      }
    }
  }
);

export const updateOrderStatusAsync = createAsyncThunk(
  type_constant.UPDATE_ORDER_STATUS_ASYNC,
  async (updatedData) => {
    try {
      const response = await apiHandle.post(
        `admin/store-status-update`,
        updatedData
      );
      const res_data = await response.data;
      return res_data;
    } catch (error) {
      console.log("error", error);
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      } else {
        throw Error(error.message);
      }
    }
  }
);
